import { useDisplayMode } from 'conversations-visitor-experience-components/contexts/DisplayModeContext';
import styled from 'styled-components';
import { WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { THREAD_VIEW } from 'conversations-visitor-experience-components/visitor-widget/constants/views';
import WidgetHeader from 'conversations-visitor-experience-components/visitor-widget/components/WidgetHeader';
import { KBSearchProvider } from 'conversations-visitor-experience-components/knowledge-base/context/KBSearchProvider';
import { getBrandStyle } from 'conversations-visitor-experience-components/visitor-widget/util/color';
import KBNavigation from 'conversations-visitor-experience-components/visitor-widget/components/KBNavigation';
import SideDockStyleWrapper from './SideDockStyleWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WidgetBodyDiv = styled.div.withConfig({
  displayName: "SideDockVisitorWidget__WidgetBodyDiv"
})(["display:flex;flex-direction:column;height:100%;background-color:", ";overflow:auto;"], WHITE);
export const WidgetBodyDivWrapper = styled.div.withConfig({
  displayName: "SideDockVisitorWidget__WidgetBodyDivWrapper"
})(["flex:1;min-height:0;display:flex;flex-direction:column;", ";"], ({
  $background
}) => getBrandStyle($background));
const SideDockVisitorWidget = ({
  backButtonDisabled,
  browserWindowHeight,
  chatHeadingConfig,
  chatHeadingResponders,
  closeWidget,
  coloring,
  children,
  createNewThread,
  customHeaderText = null,
  endChat,
  isThreadAssigned = false,
  isThreadClosed = false,
  isThreadPersisted = false,
  isThreadStarted = false,
  kbArticleDeepLink,
  restorePreviousViewFromKBArticle,
  navigateToKnowledgeBaseArticle,
  navigateBack,
  officeHoursMessage,
  setWidgetSize,
  showAvailabilityMessage,
  showBackButton,
  toggleWidgetSizeForKBArticle,
  typicalResponseTimeMessage,
  unseenThreadsCountExcludingCurrentThread,
  view = THREAD_VIEW,
  viewKBArticleExpanded,
  updateView,
  kbNavigationEnabled,
  isUngatedForCloseThread = false
}) => {
  const {
    onToggleDisplayMode,
    showDisplayModeToggle,
    widgetDisplayMode
  } = useDisplayMode();
  return /*#__PURE__*/_jsx(SideDockStyleWrapper, {
    children: /*#__PURE__*/_jsxs(KBSearchProvider, {
      children: [/*#__PURE__*/_jsx(WidgetHeader, {
        backButtonDisabled: backButtonDisabled,
        browserWindowHeight: browserWindowHeight,
        chatHeadingConfig: chatHeadingConfig,
        coloring: coloring,
        chatHeadingResponders: chatHeadingResponders,
        createNewThread: createNewThread,
        customHeaderText: customHeaderText,
        inline: false,
        isThreadAssigned: isThreadAssigned,
        isThreadClosed: isThreadClosed,
        isThreadPersisted: isThreadPersisted,
        isThreadStarted: isThreadStarted,
        kbArticleDeepLink: kbArticleDeepLink,
        restorePreviousViewFromKBArticle: restorePreviousViewFromKBArticle,
        mobile: false,
        navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
        navigateBack: navigateBack,
        officeHoursMessage: officeHoursMessage,
        onClose: closeWidget,
        onEndChat: endChat,
        toggleWidgetSizeForKBArticle: toggleWidgetSizeForKBArticle,
        setWidgetSize: setWidgetSize,
        showAvailabilityMessage: showAvailabilityMessage,
        showBackButton: showBackButton,
        typicalResponseTimeMessage: typicalResponseTimeMessage,
        unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
        view: view,
        viewKBArticleExpanded: viewKBArticleExpanded,
        isUngatedForCloseThread: isUngatedForCloseThread,
        onToggleDisplayMode: onToggleDisplayMode,
        showDisplayModeToggle: showDisplayModeToggle,
        widgetDisplayMode: widgetDisplayMode
      }), /*#__PURE__*/_jsx(WidgetBodyDivWrapper, {
        $background: coloring.accentColor,
        kbNavigationEnabled: kbNavigationEnabled,
        children: /*#__PURE__*/_jsx(WidgetBodyDiv, {
          children: children
        })
      }), kbNavigationEnabled && /*#__PURE__*/_jsx(KBNavigation, {
        coloring: coloring,
        updateView: updateView,
        view: view
      })]
    })
  });
};
SideDockVisitorWidget.displayName = 'SideDockVisitorWidget';
export default SideDockVisitorWidget;